<template>

  <div class="elevation-2 search-box white" v-if="searching">

    <v-toolbar flat="flat">
      <v-toolbar-title class="search-title">Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="search-bt"
              title="Hide the search"
              @click="closeSearch">mdi-magnify-close</v-icon>
    </v-toolbar>

    <v-container fluid="fluid" grid-list-md="grid-list-md">

      <v-layout row="row" wrap="wrap">

        <!-- SPORT -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <SportSelector ref="sportSelector"
                         :currentSportIDs="searchParams.sportID"
                         @sportSelected="sportSelected"/>
        </v-flex>

        <!-- TITLE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <v-text-field class="field"
                        v-model="searchParams.title"
                        label="Title"
                        placeholder="Title"></v-text-field>
        </v-flex>

        <!-- CAPTION -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <v-text-field class="field"
                        v-model="searchParams.caption"
                        label="Caption"
                        placeholder="Caption"></v-text-field>
        </v-flex>

        <!-- CLUB -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="clubSelector"
                           :currentClubID="searchParams.clubID"
                           :sportID="searchParams.sportID"
                           :label="'Club'"
                           @clubSelected="clubSelected"/>
        </v-flex>

        <!-- TEAM -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5" v-if="$country === 'US'">
          <TeamSelector ref="teamSelector"
                        :currentTeamID="searchParams.teamID"
                        :clubID="searchParams.clubID"
                        :disabled="!searchParams.clubID"
                        :disabledText="'Please select club first'"
                        :label="'Team'"
                        @teamSelected="teamSelected"/>
        </v-flex>

      </v-layout>

      <v-layout row="row" wrap="wrap">
        <v-spacer></v-spacer>
        <v-btn class="search-action" :small="true" color="primary" flat="flat" @click.native="clearSearch">Clear</v-btn>
        <v-btn class="search-action" :small="true" color="primary" @click.native="search">Search</v-btn>
      </v-layout>

    </v-container>

  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import NEWClubSelector from '../common/NEWClubSelector'
import TeamSelector from '../common/TeamSelector'

export default {
  name: 'Search',
  components: {
    SportSelector,
    NEWClubSelector,
    TeamSelector
  },
  props: ['searching'],
  data () {
    return {
      searchParams: {}
    }
  },
  methods: {
    search () {
      this.$emit('search', this.searchParams)
    },

    clearSearch () {
      this.$refs.sportSelector.clear()
      this.$refs.clubSelector.clear()

      if (this.$country === 'US') {
        this.$refs.teamSelector.clear()
      }

      this.searchParams = {}
      this.$emit('clearSearch')
    },

    closeSearch () {
      this.$emit('closeSearch')
    },

    sportSelected (sportid) {
      this.searchParams.sportID = sportid
    },
    clubSelected (clubid) {
      this.searchParams.clubID = clubid
    },
    teamSelected (teamid) {
      this.searchParams.teamID = teamid
    }
  }
}

</script>

<style lang="scss" scoped>

.search-box {
  margin-bottom: 30px;
}

.search-title {
  font-size: 1rem;
  font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/clips/Search.vue